module.exports = __webpack_public_path__ + "static/media/finished-little-BG.bd24102e.png";